// packages import
import { TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { FC } from "react";
// component import
import { CustomPagination } from "../common/CustomPagination";
import { StickyTable } from "../common/StickyTable";
import { CustomTasksMenu } from "../menus/CustomTasks";
import { CustomTasksSkeleton } from "../skeletons/CustomTasksSkeleton";
// others
import { CUSTOM_TASKS_TABLE_HEADERS, STANDARD_DATE_FORMAT } from "../../constants";
import { CustomTaskListingProps } from "../../interfaceTypes";

export const CustomTasksListing: FC<CustomTaskListingProps> = ({ loading, allTasks, setCurrentCustomTask }): JSX.Element => (
  <StickyTable height='346px' pagination={<CustomPagination loading={loading || false} />}>
    <TableHead>
      <TableRow>
        {CUSTOM_TASKS_TABLE_HEADERS.map((item, index) => {
          const lastItem = CUSTOM_TASKS_TABLE_HEADERS.length - 1

          return (
            <TableCell component="th" key={index} align={index === lastItem ? "right" : 'left'}>
              {item}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>

    {loading ?
      <CustomTasksSkeleton noOfRows={7} />
      :
      <TableBody>
        {allTasks?.map(task => {
          const { id, title, createdAt } = task || {}

          return (
            <TableRow key={id} hover>
              <TableCell>
                <Tooltip title={title} arrow placement='top-start'>
                  <Typography noWrap width='200px'>
                    {title}
                  </Typography>
                </Tooltip>
              </TableCell>

              <TableCell>
                <Typography noWrap maxWidth='250px'>
                  {moment(parseInt(createdAt || '')).format(STANDARD_DATE_FORMAT)}
                </Typography>
              </TableCell>

              <TableCell align="right">
                <CustomTasksMenu task={task} currentCustomTask={task} setCurrentCustomTask={setCurrentCustomTask} />
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    }
  </StickyTable>
)